import { render } from "./StarterDiscounts.vue?vue&type=template&id=00228a3f&scoped=true&ts=true"
import script from "./StarterDiscounts.vue?vue&type=script&lang=ts"
export * from "./StarterDiscounts.vue?vue&type=script&lang=ts"

import "./StarterDiscounts.vue?vue&type=style&index=0&id=00228a3f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00228a3f"]])

export default __exports__